import { ReportItem, ReportItemContent, ReportTestItem } from './entities';
import convertTestToReportItem from './convertTestItem';
import { customCompare } from './sorter';
import { countTreeItems } from './utils';

export default function convertElementToTree(
  testItems: ReportTestItem[]
): ReportItem[] {
  const elementMap: { [key: string]: ReportItem } = {};

  testItems.forEach(item => {
    const path = item.element?.path;
    
    if (!path || path.length === 0) {


      const missingElement = item.fieldSettings?.element?.required;
      let elementGroup;
      if (missingElement) {
        elementGroup = "(Missing Element)";
      } else {
        elementGroup = "(No Element)";
      }

      if (!elementMap[elementGroup]) {
        elementMap[elementGroup] = {
          id: elementGroup,
          title: elementGroup,
          content: []
        };
      }
      if (!elementMap[elementGroup].content) {
        elementMap[elementGroup].content = [];
      }
      elementMap[elementGroup].content.push(convertTestToReportItem(item));
      return;
    }

    let currentNode: ReportItem | undefined;
    let parentNode: ReportItem | undefined;

    path.forEach((pathItem, index) => {
      const nodeId = pathItem.id.toString();
      const nodeName = pathItem.name;
      const isLastLevel = index === path.length - 1;

      if (index === 0) {
        // Root level - store in elementMap
        if (!elementMap[nodeId]) {
          elementMap[nodeId] = {
            id: nodeId,
            title: nodeName,
            children: [],
            content: []
          };
        }
        currentNode = elementMap[nodeId];
      } else {
        // Child level - find or create in parent's children
        
        if (!parentNode) {
          console.error("Error: parentNode is undefined for child node:", nodeName, nodeId);
          return;
        }
        if (!parentNode.children) {
          parentNode.children = [];
        }
        
        currentNode = parentNode.children.find(child => child.id === nodeId);
        
        if (!currentNode) {
          currentNode = {
            id: nodeId,
            title: nodeName,
            children: [],
            content: []
          };
          parentNode.children.push(currentNode);
        }
      }

      if (isLastLevel) {
        if (!currentNode.content) {
          currentNode.content = [];
        }
        currentNode.content.push(convertTestToReportItem(item));
      }

      parentNode = currentNode;
    });
  });
  
  // Helper function to sort nodes recursively
  function sortNode(node: ReportItem) {
    if (node.children) {
      node.children.sort((a, b) => customCompare(a.title, b.title));
      node.children.forEach(sortNode);
    }
    if (node.content) {
      node.content.sort((a, b) => customCompare(a.title, b.title));
    }
  }

  // Sort and count all nodes
  const sortedTree = Object.values(elementMap)
    .sort((a, b) => customCompare(a.title, b.title));

  sortedTree.forEach(node => {
    sortNode(node);
    countTreeItems(node);
  });

  return sortedTree;
}
